<template>
  <div class="login">
    <el-form :model="form" :rules="rules2" ref="form" label-position="left" label-width="0" class="card-box-login loginform">
      <h3 class="title">{{systemName}}</h3>

      <el-row class="login-row">
        <el-col :span="8" class="login-label">

          <el-row style="width: 140px">
            <el-col :span="24">
              <div class="login-integrant">必須</div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div style="width: 140px">ログインID</div>
            </el-col>
          </el-row>

        </el-col>
        <el-col :span="16" class="login-input">
          <el-form-item prop="userId" >
            <el-input type="text" id = 'userId' class="login-el-input" v-model="form.userId" placeholder="ログインIDを入力してください。"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8"class="login-label">
          <el-row style="width: 140px">
            <el-col :span="24">
              <div class="login-integrant">必須</div>
            </el-col>
          </el-row>
          <el-row style="width: 140px">
            <el-col :span="24">
              <div style="">パスワード</div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div style="width: 180px">指定パスワードを入力</div>
            </el-col>
          </el-row>

        </el-col>
        <el-col :span="16" class="login-input">
          <el-form-item prop="password">
            <el-input type="password" class="login-el-input" v-model="form.password" placeholder="パスワードを入力を入力してください。"></el-input>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row style="margin-top: 0.2em">
        <el-col :span="8"class="login-label1">

          <el-row style="width: 140px">
            <el-col :span="24">
              <div class="login-integrant">必須</div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div style="width: 180px;margin-top: 10px">処理選択</div>
            </el-col>
          </el-row>

        </el-col>
        <el-col :span="16" class="login-input1">
          <el-row>
            <el-col :span="24" >
              <el-form-item prop="choiceRadio">
                <el-radio-group v-model="form.choiceRadio">
                  <ul >
                    <li> <el-radio label="1" style="padding-left: 1em">搬入状況確認</el-radio></li>
                    <li> <el-radio label="0" style="padding-left: 1em">パスワード変更</el-radio></li>
                    <li> <el-radio label="2" style="padding-left: 1em">取引先一覧</el-radio></li>
                  </ul>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row >
        <el-col :span="12">
          <el-form-item >
            <el-button type="danger" class="login-btn-left" @click.native.prevent="handleSubmit2('form')">確　認</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item >
            <el-button type="danger" class="login-btn-right" @click.native.prevent="clean()">終　了</el-button>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
  </div>
</template>

<script>
  import http from '../../assets/js/http'
  import { isAdminUserId, isEmail } from '../../assets/js/check'
  import _g from '../../assets/js/global'

  export default {
    data() {
      var checkUserId = (rule, value, callback) => {
        if (value == null || value == '') {
          callback(new Error('ログインIDを入力してください。'))
        } else if (!isEmail(value)) {
          callback(new Error('メールアドレスを入力してください。'))
        } else if (!isAdminUserId(value)) {
          callback(new Error('社内のメールアドレスを入力してください。（例：***@tokometal.co.jp|***@trimetals.co.jp）'))
        } else {
          callback()
        }
      }
      return {
        title: '',
        systemName: '夜間搬入申込サービス < 社内用 >',
        clientListData: [],
        form: {
          userId: '',
          password: '',
          choiceRadio: '1'
        },
        rules2: {
          userId: [
            { required: true, validator: checkUserId, trigger: 'blur' }
          ],
          password: [
            { required: true, message: 'パスワードを入力してください。', trigger: 'blur' }
          ],
          choiceRadio: [
            { required: true, message: '処理選択を選択してください。', trigger: 'change' }
          ]
        }
      }
    },
    methods: {
      clean() {
        document.getElementById('userId').value = ''
        var userAgent = navigator.userAgent
        if (userAgent.indexOf('Firefox') != -1 || userAgent.indexOf('Chrome') != -1) {
          window.location.href = 'about:blank'
          window.close()
        } else {
          window.opener = null
          window.open('', '_self', '')
          window.close()
        }
      },
      handleSubmit2(form) {
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.indexOf('msie') != -1 || ua.indexOf('trident/7') != -1) {
          if (window.event.which == 13) {
            return false
          }
        }
        this.$refs[form].validate((valid) => {
          if (valid) {
            let data = {}
            data.userId = this.form.userId
            data.password = this.form.password
            data.choiceRadio = this.form.choiceRadio === '1' ? 1 : 0
            this.apiPost('shanaikanrisha/Login/login', data).then((res) => {
              this.handelResponse(res, (data) => {
                if (res.code != 200) {
                  this.handleError(res)
                  return
                } else {
                  var reData = res.data
                  window.localStorage.setItem('userId', this.form.userId)
                  window.localStorage.setItem('loginRoot', reData)
                  if (this.form.choiceRadio === '1') {
                    this.resetCommonData('/shanaikanrisha/search')
                    _g.toastMsg('success', 'ログイン成功しました')
                  }
                  if (this.form.choiceRadio === '0') {
                    this.resetCommonData('/shanaikanrisha/changePwd')
                    _g.toastMsg('success', 'ログイン成功しました')
                  }
                  if (this.form.choiceRadio === '2') {
                    var userId = this.form.userId
                    this.$router.push({ path: '/shanaikanrisha/clientList', query: { userId: userId, radio: this.radio }})
                    _g.toastMsg('success', 'ログイン成功しました')
                  }
                  // this.resetCommonData('/shanaikanrisha/clientList')
                }
              })
            })
          } else {
            return false
          }
        })
      }
    },
    mounted() {
      window.addEventListener('keyup', (e) => {
        if (e.keyCode === 13) {
          this.handleSubmit2('form')
        }
      })
    },
    created() {
      window.load = function() {
        document.getElementById('userId').value = ''
        // document.getElementById('password').value = ''
        // table = document.getElementById('userId')
        // rows = table.getElementsByTagName('tr')
      }
    },
    mixins: [http]
  }
</script>

<style>
  @import url("../../assets/css/common.css");

  .login-el-input{
    margin-left: 30px;
    margin: 29px 20px 0px 20px
  }
  .login-row{
    margin-bottom: 0.1em;
  }
  .login-input{
    height: 97px;
    background-color:#F5F7F7;
  }
  .login-input1{
    height: 120px;
    background-color:#F5F7F7;
  }
  .login-label{
    height: 98px;
    padding: 1em 2em 1.2em 2em;
    background-color:#E2EBFF;
  }
  .login-label1{
    height: 120px;
    padding: 1em 2em 1.2em 2em;
    background-color:#E2EBFF;
  }
  .login-btn-left{
    margin-top: 1em;
    float: right;
    width: 150px;
  }
  .login-btn-right{
    margin-top: 1em;
    margin-left: 20px;
    width: 150px;
    float: left;
  }
  .card-box-login {
    padding: 5em;
    -webkit-border-radius: 1em;
    border-radius: 0.5em;
    -moz-border-radius: 1em;
    background-clip: padding-box;
    background-color: #F9FAFC;
    margin: 5em auto;
    width: 38em;
    border: 0.1em solid #8492A6;
  }

  .title {
    margin: 0px auto 2em auto;
    text-align: left;
    color: #505458;
  }

  .loginform {
    padding: 3em 3em 0.1em 3em
  }
</style>
<style>
  .login .el-radio{
    margin-top: 0.8em;
    font-size: 18px;
  }
  .login .el-input{
    width: 25em
  }
  .login .el-form-item__error{
    left: 8%;
  }
</style>



// WEBPACK FOOTER //
// src/components/shanaikanrisha/login.vue